import { axiosInstance } from "../axios";
const collection_route = `${process.env.REACT_APP_ORG_BASE}/collection`;
const due_followup_route = `${process.env.REACT_APP_ORG_BASE}/dueFollowup`;

export const changeDueDateOfSchool = (body) => {
  return axiosInstance.put(`${collection_route}/changeDueDateOfSchool`, body);
};

export const getSchoolListWithAmount = (params) => {
  return axiosInstance.get(`${collection_route}/getSchoolListWithAmount`, {
    params,
  });
};

export const getSchoolListBySessionWithAmount = (params) => {
  return axiosInstance.get(
    `${collection_route}/getSchoolListBySessionWithAmount`,
    {
      params,
    }
  );
};
export const collectPayment = (body) => {
  return axiosInstance.put(`${collection_route}/collectPayment`, body);
};
export const changeInvoiceDate = (body) => {
  return axiosInstance.put(`${collection_route}/changeInvoiceDate`, body);
};
export const getInvoice = (params) => {
  return axiosInstance.get(`${collection_route}/getInvoice`, {
    params,
  });
};
export const deleteInvoice = (invoiceDocId) => {
  return axiosInstance.delete(
    `${collection_route}/deleteInvoice/${invoiceDocId}`
  );
};


// due follow up APIs

export const getDueFollowUpList = (params) => {
  return axiosInstance.get(`${due_followup_route}/getFollowList`, {
    params,
  });
}

export const getDueFollowUpListBySchool = (schoolDocId) => {
  return axiosInstance.get(`${due_followup_route}/getDueFollowUpListBySchool/${schoolDocId}`, {
  });
}

export const createDueFollowupThread = (body) => {
  return axiosInstance.post(`${due_followup_route}/createDueFollowupThread`, body);
}

export const editDueFollowupThread = (payload) => {
  return axiosInstance.put(`${due_followup_route}/editDueFollowupThread/${payload.dueFollowupThreadDocId}`, payload.body);
}

export const deleteDueFollowupThread = (threadDocId) => {
  return axiosInstance.delete(
    `${due_followup_route}/deleteDueFollowupThread/${threadDocId}`
  );
}